import { all, call, put, takeLatest, select } from 'redux-saga/effects';
import API from '../../helpers/sagaApi/SagaApi';
import { getBranchId, getJwtToken } from '../sagaAuth/sagaAuthSaga';
import Actions, { SagaDeedTypes } from './sagaDeedRedux';
import { push } from 'react-router-redux';
import { buildUrl, getSagaWAPUrl, getCurrentUserId } from '../../helpers/utility';
import IDeedDetailUpdate from '../../redux/sagaDeed/IDeedDetailUpdate';
import { Result } from '../../redux/helpers/Ihelper';


export const currentLanguageRfc3066Fnc = (state) => state.Language.language.rfc3066;

export function* requestGetDeedDetail(action) {
    const tag = '[REQUEST_GET_DEED_DETAIL]';
    try {

        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (!jwtToken) {
            throw new Error('NotLoggedIn');
        }
        // step 2 : validation passed..
        const response = yield call(API.requestGetDeedDetail, jwtToken, action.contractId, action.deedId, branchId, action.userId, culture);
        if (response.status === 200 && response.data.statusCode === 200) {
            console.log(`${tag} requestGetDeedDetail response :`, response.data);
            yield put(Actions.getDeedDetailSuccess(response.data.result));
        } else {
            throw new Error(response.data.error);
        }

    }
    catch (e) {
        console.warn(`${tag} requestGetDeedDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.getDeedDetailFailure(message));
    }
}


export function* requestUpdateDeedPayment(action) {
    const tag = '[REQUEST_UPDATE_DEED_PAYMENT]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (!jwtToken) {
            throw new Error('NotLoggedIn');
        }

        const result = validateUpdateDeed(action.deedPaymentBreakDown.deedId);
        if (result.isValid) {
            // step 2 : validation passed..
            const response = yield call(API.requestUpdateDeedPayment, jwtToken, action.deedPaymentBreakDown, branchId, culture);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateDeedPayment response :`, response.data);
                yield put(Actions.updateDeedPaymentSuccess(response.data.result));
                // window.top.location.href = getSagaWAPUrl('deed',  'user', 'password', branchId, { offerId: action.deedPaymentBreakDown.offerId, contractId: action.deedPaymentBreakDown.contractId, deedId: action.deedPaymentBreakDown.deedId,activeTab: 3  });
                // yield put(push(buildUrl(`/dashboard/deedDetail/?iframe=true&offerId=${action.deedPaymentBreakDown.offerId}&contractId=${action.deedPaymentBreakDown.contractId}&deedId=${action.deedPaymentBreakDown.deedId}&activeTab=3`)));

            } else {
                throw new Error(response.data.result.error);
            }
        }
        else {
            yield put(Actions.updateDeedPaymentFailure(result.errorMessages));
        }

    }
    catch (e) {
        console.warn(`${tag} requestUpdateDeedPayment failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateDeedPaymentFailure(message));
    }
}

export function* requestUpdateDeedDetail(action) {
    const tag = '[REQUEST_UPDATE_DEED_DETAIL]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        if (!jwtToken) {
            throw new Error('NotLoggedIn');
        }
        const result = validateRequestUpdateDeedDetail(action.deedDetail);
        if (result.isValid) {
            const response = yield call(API.requestUpdateDeedDetail, jwtToken, action.deedDetail, action.userId);
            console.log('requestUpdateDeedDetail response', response);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateDeedDetail response :`, response.data);
                yield put(Actions.updateDeedDetailSuccess(response.data.result.result));
                const url = `/dashboard/deedDetail/?iframe=true&offerId=${action.offerId}&contractId=${action.deedDetail.deedInfomation.contractId}&deedId=${response.data.result.deedId}&activeTab=1`;
                yield put(push(buildUrl(url)));

            } else {
                throw new Error(response.data.result.error);
            }

        } else {

            yield put(Actions.updateDeedDetailFailure(result.errorMessages));
        }

    }
    catch (e) {
        console.warn(`${tag} requestUpdateDeedDetail failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateDeedDetailFailure(message));
    }
}


function validateRequestUpdateDeedDetail(deedDetail: IDeedDetailUpdate) {
    const result: Result = {
        isValid: false,
        errorMessages: []
    };
    if (!deedDetail) {
        result.isValid = true;
        return result;
    }
    let isValid = true;
    const errorMessage: string[] = [];

    // deed name
    if (!(deedDetail.deedInfomation.name) || deedDetail.deedInfomation.name.length === 0) {
        errorMessage.push('error.deedDetail.name');
        isValid = false;
    }

    result.isValid = isValid;
    result.errorMessages = errorMessage;
    return result;
}

function validateUpdateDeed(deedId) {
    const result: Result = {
        isValid: true,
        errorMessages: []
    };
    let isValid = true;
    const errorMessage: string[] = [];

    // deed id
    if (!(deedId) || deedId === 0) {
        errorMessage.push('error.deedDetail.id');
        isValid = false;
    }

    result.isValid = isValid;
    result.errorMessages = errorMessage;
    return result;
}

export function* requestUpdateDeedDescription(action) {
    const tag = '[REQUEST_UPDATE_DEED_DESCRIPTION]';
    try {
        const jwtToken = yield getJwtToken();
        const branchId = yield getBranchId();
        const userId = getCurrentUserId();
        if (!jwtToken) {
            throw new Error('NotLoggedIn');
        }

        const result = validateUpdateDeed(action.deed.deedId);
        if (result.isValid) {
            const response = yield call(API.requestUpdateDeedDescription, jwtToken, action.deed, userId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestUpdateDeedDescription response :`, response.data);
                yield put(Actions.updateDeedDescriptionSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/deedDetail/?iframe=true&offerId=${action.deed.offerId}&contractId=${action.deed.contractId}&deedId=${action.deed.deedId}&activeTab=2`)));

            } else {
                throw new Error(response.data.result.error);
            }

        }
        else {

            yield put(Actions.updateDeedDescriptionFailure(result.errorMessages));
        }
    }
    catch (e) {
        console.warn(`${tag} requestUpdateDeedDescription failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.updateDeedDescriptionFailure(message));
    }
}

export function* requestGenerateDeedReport(action) {
    const tag = '[REQUEST_GENERATE_DEED_REPORT]';
    try {
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        const branchId = yield getBranchId();
        const culture = yield select(currentLanguageRfc3066Fnc);
        if (jwtToken && branchId) {
            // step 2 : validation passed..
            const response = yield call(API.requestGenerateDeedReport, jwtToken, branchId, culture, action.deedId);
            if (response.status === 200 && response.data.statusCode === 200) {
                const url = getSagaWAPUrl('viewReport', null, null, branchId, { reportName: 'deedReport', resultURL: response.data.result });
                window.open(url, '_blank');
                yield put(Actions.generateDeedReportSuccess(true));
            } else {
                throw new Error(response.data.error);
            }

        } else {
            throw new Error('NotLoggedIn');
        }

    }
    catch (e) {
        console.warn(`${tag} requestGenerateDeedReport failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.generateDeedReportFailure(message));
    }
}

export function* requestRestoreDeed(action) {
    const tag = '[REQUEST_RESTORE_DEED]';
    try {
        // step 1: perform input validation
        const jwtToken = yield getJwtToken(); // IDE-Help, do not delete me
        if (jwtToken) {
            // step 2 : validation passed..
            const response = yield call(API.requestRestoreDeed, jwtToken, action.historyId, action.offerId, action.contractId, action.action, action.deedId);
            if (response.status === 200 && response.data.statusCode === 200) {
                console.log(`${tag} requestRestoreDeed response :`, response.data);
                yield put(Actions.restoreDeedSuccess(response.data.result));
                yield put(push(buildUrl(`/dashboard/deedDetail/?iframe=true&offerId=${action.offerId}&contractId=${action.contractId}&deedId=${action.deedId}&activeTab=5`)));
            } else {
                throw new Error(response.data.error);
            }
        } else {
            throw new Error('xx.yyInvalidInput'); // <-- fix me
        }
    }
    catch (e) {
        console.warn(`${tag} requestRestoreDeed failed with error :`, e);
        const message = e.message ? e.message : 'Failed';
        yield put(Actions.restoreDeedFailure(message));
    }
}


export default function* rootSaga() {
    yield all([
        takeLatest(SagaDeedTypes.REQUEST_GET_DEED_DETAIL, requestGetDeedDetail),
        takeLatest(SagaDeedTypes.REQUEST_UPDATE_DEED_PAYMENT, requestUpdateDeedPayment),
        takeLatest(SagaDeedTypes.REQUEST_UPDATE_DEED_DETAIL, requestUpdateDeedDetail),
        takeLatest(SagaDeedTypes.REQUEST_UPDATE_DEED_DESCRIPTION, requestUpdateDeedDescription),
        takeLatest(SagaDeedTypes.REQUEST_GENERATE_DEED_REPORT, requestGenerateDeedReport),
        takeLatest(SagaDeedTypes.REQUEST_RESTORE_DEED, requestRestoreDeed),
    ]);
}


// WEBPACK FOOTER //
// ./src/redux/sagaDeed/sagaDeedSaga.ts